import React from 'react';

export default class DataCanvas extends React.Component {
  render() {
    return (
      <div className='data-canvas'>
        {this.props.img}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/DataCanvas.js